import axios from "axios";
import { New_SubjectCategory } from "../../../api/api"
import { toast } from 'react-toastify';
import { useState } from "react";
import { Link } from 'react-router-dom';

import useCategoryList from './../../../hooks/useCategoryList';
import CategorySideBar from './components/CategorySideBar';


const Category = () => {

     const [loading, setLoading] = useState(false);
     const [refresh, setRefresh] = useState(false)

     const CategoryList = useCategoryList(refresh, setRefresh)


     const SubmitHandle = async (e) => {
          e.preventDefault()
          setLoading(true)
          setRefresh(true)

          try {
               const res = await axios.post(New_SubjectCategory, {
                    "title": e.target.categoryName.value,
                    "parentId": e.target.categoryParent.value > 0 ? e.target.categoryParent.value : null
               });
               toast.success('دسته بندی جدید ساخته شد.')
               e.target.categoryName.value = ''
               e.target.categoryParent.value = 0

          } finally {
               setLoading(false)
          }
     }


     return (
          <>
               <div className="contentHolder">
                    <div className="row">
                         <div className="col-md-6">
                              <div className="box_radios">
                                   <div className="headHolder bordered"><p className="title">افزودن دسته بندی جدید</p></div>

                                   <div className="newCategory" style={{ padding: '20px' }}>
                                        <form onSubmit={SubmitHandle}>
                                             <p><input type="text" name="categoryName" id="categoryName" placeholder="عنوان" required /></p>
                                             <p><label style={{ fontSize: '14px' }}>دسته بندی مادر : {' '}
                                                  <select name="categoryParent" id="categoryParent">
                                                       <option value="0">هیچکدام</option>
                                                       {CategoryList && CategoryList.map(cat => (
                                                            <option key={cat.id} value={cat.id}>{cat.title}</option>
                                                       ))}
                                                  </select>
                                             </label></p>

                                             {loading === true ?
                                                  (<p><button type="submit" className="disabled">لطفا صبر کنید...</button></p>)
                                                  :
                                                  (<p><button type="submit">ساخت دسته بندی</button></p>)
                                             }

                                        </form>
                                   </div>
                              </div>
                         </div>
                         <div className="col-md-6">
                              <div className="box_radios">
                                   <div className="headHolder bordered"><p className="title">دسته بندی ها</p></div>

                                   <div className="categorys" style={{ padding: '20px' }}>
                                        <ul>
                                             <CategorySideBar data={CategoryList} refresh={refresh} setRefresh={setRefresh} />
                                        </ul>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

          </>
     )
}
export default Category